import React, { useMemo, useRef } from "react";
import "../../Assets/Css/Project.scss";
import Table from "../../Components/Table";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { customStyle } from '../../Components/Style'
import { useState } from "react";
import { connect } from "react-redux";
import Select from 'react-select'
import { deletePurchaseInvoices, getInvoices, getPurchaseInvoices, getSystemSettings, importPurchaseInvoiceCSV } from "../../Services/Invoices/action";
import qs from "query-string";
import { getAuthHeader } from "../../Lib/utils";
import { toast, ToastContainer } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";
import { getClients } from '../../Services/Clients/action'
import { api, DefaultCurrencykey } from "../../Lib/constants";
import CustomCalendar from '../../Components/CustomCalendar';


const Project = (props) => {
    const location = useLocation();
    const [checked, setChecked] = useState(false);
    const [selectedId, setSelectedId] = useState([]);
    const [params, setParams] = useState({});
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportrLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [inData, setInData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const fileInputRef = useRef(null);
    const modalRef = useRef(null);

    const navigate = useNavigate();

    const header = [
        { field: "checkbox" },
        { field: "ID" },
        { field: "Code" },
        { field: "Project" },
        { field: "Client" },
        { field: "Progress" },
        { field: "Status" },
        { field: "Action" },
    ];

    const ProjectStatus = [
        { value: "All", label: "All" },
        { value: "Overdue", label: "Overdue" },
        { value: "In Progress", label: "In Progress" },
        { value: "Not Started", label: "Not Started" },
        { value: "On Hold", label: "On Hold" },
        { value: "Cancelled", label: "Cancelled" },
        { value: "Finished", label: "Finished" },
    ];

    const ProjectProgress = [
        { value: "0% - 20%", label: "0% - 20%" },
        { value: "21% - 40%", label: "21% - 40%" },
        { value: "41% - 60%", label: "41% - 60%" },
        { value: "61% - 80%", label: "61% - 80%" },
        { value: "81% - 99%", label: "81% - 99%" },
        { value: "100%", label: "100%" },
    ];

    let footer = true;
    let count = props?.purchaseInvoice?.length;

    useEffect(() => {
        setIsLoading(true)
        props.getPurchaseInvoices();
        props.getSystemSettings();
        props.getClientsList();
        fetchData();
        setIsLoading(false)
    }, [location.search]);

    const fetchData = async () => {
        try {
            setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
            await props.getInvoicesList(location.search);
        } catch (error) {
            console.error("Error fetching invoices:", error);
        }
    };

    const showToastMessage = (error) => {
        toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
        });
    };

    useEffect(() => {
        props?.purchaseInvoice
            ? setInData(
                props?.purchaseInvoice?.map((purchaseinvoice) => {

                    return {
                        checkbox: {
                            value: purchaseinvoice?.id,
                            type: "checkbox",
                        },
                        ID: {
                            value: `#${purchaseinvoice?.id}`,
                            type: "text",
                        },
                        "Code": {
                            value: "CD_14-726",
                            type: "text",
                        },
                        "Project": {
                            value: "Sample Project",
                            type: "text",
                        },
                        Status: {
                            value: 'inprogress',
                            type: 'status'
                        },
                        "Client": {
                            value: "Close Digit",
                            type: "text",
                        },
                        "Progress": {
                            value: 80,
                            type: "progressbar",
                        },
                        Action: {
                            value: "/project/edit",
                            value2: "/project/view",
                            type: "action",
                        },
                    };
                })
            )
            : setInData([]);
    }, [props?.purchaseInvoice, props?.systemsettings]);

    const handleClose = () => {
        setShowModal(false);
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleClose();
                setFileName('');
                setSelectedFile(null);
                fileInputRef.current.value = null;
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClose]);

    const handleFileChange = (event) => {
        const f = event.target.files[0];
        setSelectedFile(f);
        if (f) {
            setFileName(f.name);
        } else {
            setFileName('');
        }
    }

    const handleImportClick = async (event) => {
        try {
            setLoading(true);

            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const csvData = e.target.result;
                    await props.importPurchaseInvoiceCSV(selectedFile, csvData);
                    setLoading(false);
                    setFileName('');
                    setSelectedFile(null);
                    fileInputRef.current.value = null;
                } catch (error) {
                    setHasError(true);
                    console.error('Error importing purchse invoices:', error);
                    toast.error('Error importing purchse invoices:', error.message);
                    setLoading(false)

                }
            };

            reader.readAsText(selectedFile);

        } catch (error) {
            setHasError(true);
            console.error('Error importing transactions:', error);
            toast.error('Error importing transactions:', error.message);
            setLoading(false)
        }
    };

    const handleChange = (e) => {
        if (e[1] == "headerAll" && e[0] === true) {
            setTotalSelectedIds([...e[2]]);
        } else if (e[0] === true && e[1] !== "headerAll") {
            setTotalSelectedIds([...totalSelectedIds, e[1]]);
        } else if (e[1] == "headerAll" && e[0] === false) {
            setTotalSelectedIds([]);
        } else {
            let filterdId = totalSelectedIds.filter((item) => {
                return item != e[1];
            });
            setTotalSelectedIds(filterdId);
        }
    };

    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
                setDeleteLoading(true);
                await props.deletePurchaseInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportrLoading(true);
                await handlePdfDownload(ids);
                toast.success("Exported Successfully");
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
            setDeleteLoading(false);
        }
    };

    const handlePdfDownload = async (ids) => {
        try {
            for (let id of ids) {
                let result = await api(
                    `invoices/generate/pdf`,
                    "post",
                    { ids: [id] },
                    getAuthHeader(),
                    { responseType: "blob" }
                );
                const url = window.URL.createObjectURL(result.data);
                downloadURI(url, `${id}.pdf`);
            }
            setExportrLoading(false);
        } catch (error) {
            let errorMessage = error?.message;
            showToastMessage(errorMessage);
            setExportrLoading(false);
        }
    };

    function downloadURI(uri, name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    useEffect(() => {
        if (totalSelectedIds.length > 0) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    }, [totalSelectedIds]);

    const handleAddClick = () => {
        navigate('/project/add');
    }

    const initialState = {
        projectstatus: null,
        date: "",
        projectprogress: null
    }

    const [clientData, setClientData] = useState(initialState);

    return (
            <div className="project-main">
                <div className="page-title">
                    <h4>Project</h4>
                </div>

                <div className="row">
                    <div className="col-lg-4">
                        <div className="input-group">
                            <Select
                                options={ProjectStatus}
                                styles={{
                                    ...customStyle,
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 2,
                                    }),
                                }}
                                value={clientData.projectstatus}
                                placeholder="All"
                                onChange={(val) => {
                                    setClientData((preVal) => ({
                                        ...preVal,
                                        projectstatus: val
                                    }));
                                }}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="input-group">
                            <CustomCalendar />
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="input-group">
                            <Select
                                options={ProjectProgress}
                                styles={{
                                    ...customStyle,
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 2,
                                    }),
                                }}
                                value={clientData.projectprogress}
                                placeholder="Progress"
                                onChange={(val) => {
                                    setClientData((preVal) => ({
                                        ...preVal,
                                        projectprogress: val
                                    }));
                                }}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                        </div>
                    </div>
                </div>

                <div className="gap-4 addproject-export-btn">
                    <button className="custom-project-btn" disabled={props.loading} onClick={handleAddClick}>
                        {props.loading ? <Spinner as="span" animation="border" role="status" aria-hidden="true" /> : "Add Project"}
                    </button>

                    <button
                        className="export-btn"
                        id="exportBtn"
                        disabled={!checked || exportLoading}
                        onClick={(e) => {
                            e.preventDefault();
                            handleClick(totalSelectedIds, "export");
                        }}
                    >
                        {exportLoading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            "Export"
                        )}
                    </button>
                </div>

                <div className="invoice-table-part">
                    <Table
                        header={header}
                        data={inData}
                        footer={footer}
                        count={count}
                        checked={checked}
                        records={count}
                        totalSelectedIds={totalSelectedIds}
                        defaultParams={params}
                        selectedId={selectedId}
                        handleChange={handleChange}
                        loading={props.loading}
                        showIsEdit={true}
                        showIsDelete={true}
                    />
                </div>
            </div>
    );
};

const mapStateToProps = (state) => {
    return {
        invoices: state.invoicesReducer.invoices.rows,
        count: state.invoicesReducer.invoices.count,
        loading: state.invoicesReducer.loading,
        success: state.invoicesReducer.success,
        records: state.invoicesReducer.invoices.noOfRecords,
        systemsettings: state.invoicesReducer.systemsettings,
        purchaseInvoice: state.invoicesReducer.purchaseInvoice,
    };
};

export const mapDispatchToProps = {
    getInvoicesList: getInvoices,
    deletePurchaseInvoices: deletePurchaseInvoices,
    getSystemSettings: getSystemSettings,
    getClientsList: getClients,
    importPurchaseInvoiceCSV: importPurchaseInvoiceCSV,
    getPurchaseInvoices: getPurchaseInvoices,
};

export default connect(mapStateToProps, mapDispatchToProps)(Project);
